const cfg = {
  // serverUrl: 'http://193.112.80.164'
  serverUrl: 'http://sit.whhda.xyz/backstage'
}

export const axiosConfig = {
  baseURL: cfg.serverUrl,
  timeout: 10000,
  responseType: 'json',
  withCredentials: false, // 是否允许带cookie这些
}
